
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

@Component
export default class ModalReport extends Vue {

  /* PROP */

  @Prop({default: false})
  private isShow: boolean;
  @Prop({default: 'Pilih alasan untuk melaporkan iklan ini:'})
  private title: string;

  /* INITIALIZATION */

  constructor() {
    super();
  }

  /* EMIT */
  @Emit('reported')
  private clickReporting(suspension_reason: string) {
    // Todo
  }
}
